export enum AppicationsItemIds {
  Isc = 'Isc',
  Milestone = 'Milestone',
  SecuMod = 'SecuMod',
}

export enum UserItemIds {
  FeatureRequest = 'FeatureRequest',
  Preferences = 'Preferences',
  ReportBug = 'ReportBug',
  UserGuide = 'UserGuide',
}
